import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PageTitle from 'components/PageTitle';
import Button from 'components/Button';
import CheckableInput from 'components/CheckableInput';
import { setStorage } from 'utilz';
import { URLS } from 'config';
import containerActions from './actions';

export const experienceData = {
  0: 'Under one year',
  1: 'More one year',
  2: 'Three years and more'
};

class ExperiencePage extends React.Component {
  selectExperienceHandl = (e) => {
    this.props.experienceChangeHandl(e.target.value);
  };

  sendData = () => {
    this.props.experienceSend(() => {
      setStorage({
        experience: {
          experience: this.props.experience
        }
      });
      this.props.history.push(URLS.MOUNTHLY);
    });
  }

  render() {
    return (
      <div className="page-experience">
        <PageTitle>
           What is your working <span> experience? </span>
        </PageTitle>
        <div className="experience-list">
          {
          Object.keys(experienceData).map(el => (
            <CheckableInput
              name="experience"
              changeHandl={this.selectExperienceHandl}
              value={el}
              key={el}
              checked={this.props.experience === el}
            >
              {experienceData[el]}
            </CheckableInput>
          ))
        }
        </div>
        <Button
          onClick={this.sendData}
          disabled={!this.props.experience}
        >
          Select experience
        </Button>
      </div>
    );
  }
}

ExperiencePage.propTypes = {
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  experienceChangeHandl: PropTypes.func.isRequired,
  experienceSend: PropTypes.func.isRequired,
  experience: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired
};

const mapStateToProps = state => ({
  experience: state.experience.experience
});

export default connect(mapStateToProps, containerActions)(ExperiencePage);



// WEBPACK FOOTER //
// ./src/pages/Experience/index.js